import { z } from 'zod'
import { fullIndexerPatentDetailsSchema } from './indexer-patent'

export const indexerPatentDetailsResponseSchema = z.object({
  results: z.array(
    fullIndexerPatentDetailsSchema.pick({
      document_number: true,
      title: true,
      publication_date: true,
      current_assignees: true,
    })
  ),
})

export type IndexerPatentDetailsResponse = z.infer<
  typeof indexerPatentDetailsResponseSchema
>
